import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Resource } from '../../../graphql/resources.datatypes';

interface AvailableRoomBanksData {
  availableRoomBanks: Resource[],
}

export const GET_AVAILABLE_ROOM_BANKS_QUERY = gql`
  query availableRoomBanks($id: Int!){
    availableRoomBanks(id: $id) {
      id
      internal_name
    }
  }
`;

export const availableRoomBanks = (resourceId: number | null) => {
  const id = resourceId? resourceId : -1;
  return useQuery<AvailableRoomBanksData>(
    GET_AVAILABLE_ROOM_BANKS_QUERY,
    {
      variables: {id}
    }
  );
};

export default availableRoomBanks;